import { Component, OnInit, inject } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {AccountService} from '../core/auth/account.service';
import {filter, map} from 'rxjs/operators';
import {Company, ICompany} from '../../shared/model/company.model';
import { MatCard, MatCardTitle } from '@angular/material/card';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-switch-company',
    templateUrl: './switch-company.component.html',
    styleUrls: ['./switch-company.component.css'],
    imports: [MatCard, MatCardTitle, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatError, MatButton, MatProgressSpinner]
})
export class SwitchCompanyComponent implements OnInit {
  private http = inject(HttpClient);
  private toastr = inject(ToastrService);
  private router = inject(Router);
  private fb = inject(UntypedFormBuilder);
  private accountService = inject(AccountService);


  apiUrl = environment.apiUrl;
  error = '';
  listJsonCompanies: Company[];
  displayedColumns: string[] = ['company', 'delete'];
  isLoading = false;
  companyValue = '';
  formAddNewCompany: UntypedFormGroup = this.fb.group({
    company: [this.companyValue, [Validators.required]]
  });

  ngOnInit(): void {
    this.loadData();
  }

  public switchCompany(siret: string, auxiliaire: string, tiers: string): void {
    this.http.get(this.apiUrl + '/user/change/' + tiers, {observe: "response", responseType: 'text'}).pipe(
      filter((res: HttpResponse<string>) => res.ok),
      map((res: HttpResponse<string>) => res.body)
    ).subscribe((token: string) => {
      localStorage.setItem('accessToken', token);
      /* eslint @typescript-eslint/no-unsafe-member-access: 0 */
      /* eslint @typescript-eslint/no-unsafe-assignment: 0 */
      const jsonObject = JSON.parse(atob(token.split('.')[1]));
      localStorage.setItem('tiers', String(jsonObject.codeClient));
      this.router.navigate(['bills']);
    }, () => {
      this.showError('Une erreur est survenue');
    });

  }

  public delete(company: ICompany): void {
    if (confirm('Êtes-vous sûr de vouloir supprimer l\'entreprise ' + company.raisonSociale + ' de votre compte?')) {
      this.http.get(this.apiUrl + '/company/delete/' + company.tiers, {observe: 'response', responseType: 'text'})
        .subscribe(() => {
          this.showSuccess('Suppression de votre entreprise réussie');
          this.loadData();
        }, () => {
          this.showError('Merci de réessayer dans quelques instants');
        });
    }
  }

  addNewCompany(): void {
    const company = new Company();
    if (this.companyValue.length === 14) {
      company.siret = this.companyValue;
    } else {
      company.tiers = this.companyValue;
    }
    this.isLoading = true;
    this.http.post(this.apiUrl + '/company/add', company, {observe: 'response', responseType: 'text'})
      .subscribe(() => {
        this.showSuccess('Ajout de votre entreprise réussie');
        this.formAddNewCompany.reset();
        this.loadData();
      }, (error: string) => {
        this.isLoading = false;
        switch (error) {
          case 'ERR_USER_COMPANY_NOT_MATCH':
            this.showError('Ce numéro de SIRET/code client n\'est pas associé à votre compte In Extenso');
            break;

          case 'ERR_COMPANY_ALREADY_EXIST':
            this.showError('Cette entreprise a déjà été ajoutée à votre liste');
            break;

          default:
            this.showError('Merci de réessayer dans quelques instants');
            break;
        }
      });
  }

  showSuccess(message: string): void {
    this.toastr.success(message, 'OK', {
      timeOut: 3000
    });
  }

  showError(error: string): void {
    this.toastr.error(error, 'Erreur', {
      timeOut: 3000
    });
  }

  private loadData(): void {
    this.http.get<Company[]>(this.apiUrl + '/company/all', {observe: 'response'})
      .pipe(
        filter((res: HttpResponse<Company[]>) => res.ok),
        map((res: HttpResponse<Company[]>) => res.body)
      )
      .subscribe((companies: Company[]) => {
        this.listJsonCompanies = companies;
        this.listJsonCompanies.forEach(company => {
          if (company.tiers === undefined || company.auxiliaire === undefined) {
            this.updateCompany(company);
          }
        });
        this.isLoading = false;
      }, () => {
        this.showError('Impossible de récupérer votre utilisateur');
      });
  }

  private updateCompany(company: ICompany) {
    this.http.post<ICompany>(this.apiUrl + '/company/update', company, {observe: 'response'})
      .pipe(
        filter((res: HttpResponse<ICompany>) => res.ok),
        map((res: HttpResponse<ICompany>) => res.body)
      )
      .subscribe(() => {
        this.isLoading = false;
      }, (error: HttpErrorResponse) => {
        this.isLoading = false;
        switch (error.error) {
          case 'ERR_USER_COMPANY_NOT_MATCH':
            break;
        }
      });
  }
}
